export const acceptTermsStepText = {
  head: "Samþykkja skilmála",
  main: "Vinsamlegast samþykktu notendaskilmála til þess að geta haldið áfram.",
};
